import { Box, Grid } from '@mui/material';
import InputForm from "../../../InputT";
import ParamsPicklist from "../../../../Types/ParamsPicklist";
import SearInputG from "../../../SearchInput";
import CheckboxF from '../../../ChexBox';
import SelectOption from '../../../SelectOption';
import { Input } from 'antd';

// Paramètres de recherche pour le code Salam
let searchParamsSalam: ParamsPicklist = {
  CodeAgence: '', Table: "ParamsSalam", Colonne1: "CodeSalam", Colonne2: "LibelleSalam", Colagence: '101', Choix: 22
};
let searchWorkflow  : ParamsPicklist = { CodeAgence: 'SALAM', Table: "WorkflowEtape", Colonne1: "EtapeID", Colonne2: "LibelleEtape", Colagence: 'CodeFinancement', Choix: 22 }
interface Tab1Props {
  etatG?: boolean;
  form?: any;
}



const Tab1 = (props: Tab1Props) => {
  return (
    <div className="tabItem">
      <Box fontStyle="inherit" className="border" width={"85%"} position={"absolute"}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}>
            <SearInputG
              notRequired dissabledCode={props.etatG} width={7}
              Titre="Recherche" label="Type de Salam" name="CodeSalam"
              Parametre={searchParamsSalam} form={props.form}
            />
          </Grid>
          <Grid item xs={16} md={6}>
            <InputForm width={3} label="Libellé" type="text" name="LibelleSalam" />
          </Grid>
          <Grid item xs={16} md={4}>
            <InputForm width={12} label="Délai livraison max (jours)" type="number" money name="DelaiLivraisonMaxJours" />
          </Grid>
          <Grid item xs={12} md={4}>
            <InputForm width={12} label="Taux pénalité retard (%)" type="number" pourcent name="TauxPenaliteRetard" />
          </Grid>


          <Grid item xs={12} md={4} display={"flex"} alignItems={"center"}>
            <CheckboxF width={16} label="Actif" name="IsActif" />
          </Grid>
          <Grid item xs={12} md={4}>
            <InputForm width={12} label="Montant max auto" type="number" money name="MontantMaxAuto" />
          </Grid>
          <Grid item xs={12} md={4}>
            <InputForm width={12} label="Montant min tax" type="number" money name="MontantMintax" />
          </Grid>
          <Grid item xs={12} md={4}>
            <InputForm width={12} label="Nbr max autorises par client" type="number" money name="NbrMaxAuto" />
          </Grid>
          <Grid item xs={12} md={4}>
            <InputForm width={12} label="Montant fonds garantie" type="number" money name="MontantFondGarantie" />
          </Grid>
          <Grid item xs={12} md={4}>
            <InputForm width={12} label="Taux fonds garantie (%)" type="number" pourcent name="TauxFondGarantie" />
          </Grid>
          <Grid item xs={12} md={4}>
              <CheckboxF width={12} label="Garantie Obligatoire ?" name="IsGarantieObligatoir" />
          </Grid>
          <Grid item xs={12} md={4}  >
            <SelectOption Size={'middle'}   label="Workflow Frais"   name="WorkflowFrais" Parametre={searchWorkflow}  />
          </Grid>
            
          
          <Grid item xs={12} md={4} display={"flex"} alignItems={"center"}>
            <CheckboxF width={16} label="Taxable" name="Istaxable" />
            <Input width={1} type="number" disabled name="tax"/>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Tab1;